import { Navigate, Route } from 'react-router-dom';

import { Provider as HeaderProvider } from '@dpdgroupuk/ai-app';

import {
  EMPTY_ROUTE,
  PAGE_START,
  ROUTES_PAGE,
  SECTION_FULL_PAGE,
} from '../constants/routes';
import theme from '../components/styles/theme';
import PlannerPage from '../pages/planner';
import axiosApi from '../services/axiosApi';
import UserProvider from './UserProvider';
import { Quantum } from '../components/icons';
import SomethingWentWrong from '../components/SomethingWentWrong';

const PROJECT_NAME = <Quantum />;

const PAGE_TITLE_MAPPER = [
  {
    routeName: EMPTY_ROUTE,
    pageTitle: PROJECT_NAME,
  },
  {
    routeName: PAGE_START,
    pageTitle: PROJECT_NAME,
  },
  {
    routeName: ROUTES_PAGE,
    pageTitle: PROJECT_NAME,
  },
  {
    routeName: SECTION_FULL_PAGE,
    pageTitle: PROJECT_NAME,
  },
];

const AppRouter = () => (
  <HeaderProvider
    axiosInstance={axiosApi}
    projectName={PROJECT_NAME}
    mainProjectApiUrl={process.env.REACT_APP_ORACLE_BASE_DOMAIN}
    pageTitleMapper={PAGE_TITLE_MAPPER}
    themeConfig={theme}
  >
    <Route
      element={<UserProvider />}
      errorElement={<SomethingWentWrong page={PAGE_START} />}
    >
      <Route index path="/*" element={<PlannerPage />} />
    </Route>
    <Route path={EMPTY_ROUTE} element={<Navigate to={PAGE_START} replace />} />
  </HeaderProvider>
);

export default AppRouter;
